import React from 'react';
import Abnormality from './Abnormality';
import { handleDelayValidations } from '../../../shared/utils/handleDelayValidations';
import { I18N } from '../../../constants';

const delayReasons = [
    {
        eventKey: 'Accident on the road',
        label: 'Accident on the road',
    },
    {
        eventKey: 'Delay at supplier - Loading performance',
        label: 'Delay at supplier - Loading performance',
    },
    {
        eventKey: 'Delay at supplier - Other OEM',
        label: 'Delay at supplier - Other OEM',
    },
    {
        eventKey: 'Delay due to supplier OWT',
        label: 'Delay due to supplier OWT',
    },
    {
        eventKey: 'Delay from previous supplier collection',
        label: 'Delay from previous supplier collection',
    },
    {
        eventKey: 'Delayed departure due to dock delay',
        label: 'Delayed departure due to dock delay',
    },
    {
        eventKey: 'Delayed departure due to stringing: previous loop delay',
        label: 'Delayed departure due to stringing: previous loop delay',
    },
    {
        eventKey: 'Driving ban',
        label: 'Driving ban',
    },
    {
        eventKey: 'Driver no show',
        label: 'Driver no show',
    },
    {
        eventKey: 'Driver mistake',
        label: 'Driver mistake',
    },
    {
        eventKey: 'Equipment breakdown (Tractor/Trailer)',
        label: 'Equipment breakdown (Tractor/Trailer)',
    },
    {
        eventKey: 'Ferry issue',
        label: 'Ferry issue',
    },
    {
        eventKey: 'LP Data not followed',
        label: 'LP Data not followed',
    },
    {
        eventKey: 'Rail issue',
        label: 'Rail issue',
    },
    {
        eventKey: 'Road blocked / diversion',
        label: 'Road blocked / diversion',
    },
    {
        eventKey: 'Stopped by police',
        label: 'Stopped by police',
    },
    {
        eventKey: 'Traffic Jam',
        label: 'Traffic Jam',
    },
    {
        eventKey: 'Weather condition',
        label: 'Weather condition',
    },
    {
        eventKey: 'Wrong Planning TME - Specify in the comment box',
        label: 'Wrong Planning TME - Specify in the comment box',
    },
    {
        eventKey: I18N.ABNORMALITY_LOCATION.OTHER,
        label: I18N.ABNORMALITY_LOCATION.OTHER,
    },
];

export default class Delay extends React.Component {
    render() {
        return (
            <Abnormality
                reasons={delayReasons}
                validations={handleDelayValidations}
                {...this.props}
            />
        );
    }
}
